(async () => {
  if (document.getElementById('AddEditPropertyApp')) {
    await import('@js/admin-addedit-property');
  }

  if (document.getElementById('SignTenancyApp')) {
    await import('@js/sign-tenancy');
  }

  if (document.getElementById('ShortlistApp')) {
    await import('@js/shortlist');
  }

  if (document.getElementById('landlord_properties')) {
    await import('@js/landlord-properties');
  }

  if (document.getElementById('LandlordEnquiriesApp')) {
    await import('@js/landlord-enquiries');
  }

  if (document.getElementById('UploadUtilitiesFormsApp')) {
    await import('@js/upload-utilities-forms');
    await import('@components/Shared/Inputs/UhCheckboxToggle');
  }

  if (document.getElementById('AddEditFeedApp')) {
    await import('@js/addeditfeed');
  }

  if (document.getElementById('utilitiesForm')) {
    await import('@js/edit-utilities-form');
  }
})();
